/* Publish by EComposer at 2026-10-01 15:21:25*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tntm7v6y81k"]=  window.__ectimmers["ecom-tntm7v6y81k"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-tntm7v6y81k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tntm7v6y81k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9q1n8ik3ho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9q1n8ik3ho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e1u8kfuk4x4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e1u8kfuk4x4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8wiuevti35f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8wiuevti35f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j2zic9ahp6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j2zic9ahp6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nmkkfc2we5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nmkkfc2we5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sipi55ay9w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sipi55ay9w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9u7579n1ipd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9u7579n1ipd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ap5vc11w4b7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ap5vc11w4b7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5rdluargq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5rdluargq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iw69lypv2xs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iw69lypv2xs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u5d4lv12sac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u5d4lv12sac', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8cuo2vw9b6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8cuo2vw9b6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5mtf9lo03m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5mtf9lo03m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q4ry8sz7r2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q4ry8sz7r2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1q065odw7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1q065odw7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2w5d8ckyht7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2w5d8ckyht7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urbcgewloh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urbcgewloh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5r2elcu339l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5r2elcu339l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v4g7drwkqni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4g7drwkqni', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k6zjkv1o91').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k6zjkv1o91', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ylk2ncejywh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ylk2ncejywh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pfkh0jbkyn9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pfkh0jbkyn9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8zf59k3mncd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zf59k3mncd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1yw9trl7v7i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1yw9trl7v7i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f1kod8elmhq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f1kod8elmhq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tu7gwk80ewa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tu7gwk80ewa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ui828570zqe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ui828570zqe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0jyecor89xqv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0jyecor89xqv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u5y1bfflfm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u5y1bfflfm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z5np4wzv5x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z5np4wzv5x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5dvzdi3t5p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5dvzdi3t5p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ifdtrhyf16').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ifdtrhyf16', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0vmi7ciufig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0vmi7ciufig', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3423rtfendi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3423rtfendi', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7mvg817v8c9"]=  window.__ectimmers["ecom-7mvg817v8c9"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-7mvg817v8c9"]["7uhz2y8mf"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-7mvg817v8c9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7mvg817v8c9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-086465mc2xuj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-086465mc2xuj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hem7c5gmzyo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hem7c5gmzyo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-if3bsoy9bwb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-if3bsoy9bwb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1w5er1yj0uw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1w5er1yj0uw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q62yyof6gj9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q62yyof6gj9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3xpwikbobz7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3xpwikbobz7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5pba8awvt9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5pba8awvt9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5f6zpv6xb4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5f6zpv6xb4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n9ed719q3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n9ed719q3g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iquutm7e56g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iquutm7e56g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rwa16ty8er8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rwa16ty8er8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oh9csqy7s19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oh9csqy7s19', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n4rksbsd9i8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n4rksbsd9i8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g509a1ewej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g509a1ewej', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sojg8yyi0k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sojg8yyi0k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t6g39ibxkc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t6g39ibxkc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-96cza48fjns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-96cza48fjns', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v8f6a0uz4uj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v8f6a0uz4uj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9c54fckngp7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9c54fckngp7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6calg9tzzjp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6calg9tzzjp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dgc1fqepnpp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dgc1fqepnpp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u4drcogjn1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u4drcogjn1', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-p4pnt7n0edp"]=  window.__ectimmers["ecom-p4pnt7n0edp"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,o=this.settings.autoplay,n=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const f=t.querySelector(".ecom-element_video-iframe");n&&setTimeout(function(){b(f)},500);function b($){let A={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,A).observe($)}function y($,A){let I={handleMouseenter:j,handleMouseleave:T,handleEnded:L};function j(){$.readyState>=c&&$.pause()}function T(){$.readyState>=c&&$.play()}function L(){v($,I)}if(r){$.addEventListener("mouseenter",j),$.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",j),O.addEventListener("mouseleave",T)),A||$.addEventListener("ended",L)}}function v($,A){if(A){const{handleMouseenter:I,handleMouseleave:j,handleEnded:T}=A;let L=t.querySelector(".ecom-video_link-extra");$.removeEventListener("mouseenter",I),$.removeEventListener("mouseleave",j),$.removeEventListener("ended",T),L&&L.href&&(L.removeEventListener("mouseenter",I),L.removeEventListener("mouseleave",j))}}function w($,A){$.forEach(function(I){if(I.isIntersecting){const j=I.target.querySelector("video source"),T=I.target.querySelector("video"),L=I.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){o&&T.play()})),L){let O=L.dataset.srcVideo;L.setAttribute("src",O)}A.unobserve(I.target)}})}let k=t.querySelector(".ecom_video"),S=t.querySelector(".ecom_iframe");a&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),o&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if(S){let $=S.getAttribute("src");$.includes("autoplay=0")?$=$.replace("autoplay=0","autoplay=1"):$=$+"&autoplay=1",S.setAttribute("src",$),l?setTimeout(()=>{$=$.replace("autoplay=1","autoplay=0"),S.setAttribute("src",$)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function($){$.dataset.ecTrackingId&&$.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:$.id,tracking_id:$.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]");if(z&&this.settings.image_overlay&&l&&window.EComModal){const $=z.dataset.width,A=z.dataset.height;var E=this.id;new window.EComModal(z,{cssClass:[E,"ecom-core","ecom-core-simulator"],onOpen:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-modal-box__content");j.classList.add("ecom-element_video-iframe");const T={width:$,height:A};Object.assign(j.style,T)}},onClose:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-element_video-iframe iframe");j&&(j.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-p4pnt7n0edp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p4pnt7n0edp', settings: {"loop":false,"autoplay":false,"click_to_play_pause":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mgxdh61nc7t"]=  window.__ectimmers["ecom-mgxdh61nc7t"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-mgxdh61nc7t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgxdh61nc7t', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}